import React from 'react';
import Lottie from 'react-lottie';
import * as loaderLottie from "../../assets/8parts-logo.json";
import ndcsSmallLoader from "../../images/white-loader.gif"
import { useInstance } from '../../context/instance.context';

const SmallGlobalLoader = ({ height = 100, width = 200 }) => {
    const { name, allInstanceData } = useInstance();
    const isNdcs = name == allInstanceData.NDCS;
    return (
        <div>
            {!isNdcs ? < Lottie
                options={{
                    loop: true,
                    autoplay: true,
                    animationData: loaderLottie,
                    rendererSettings: {
                        preserveAspectRatio: 'xMidYMid slice'
                    }

                }}
                width={100}
            /> : <img className='h-7' src={ndcsSmallLoader} />}
        </div>

    );
};

export default SmallGlobalLoader;
